
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Apps</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card v-if="app">
                        <v-card-text>
                          App bearbeiten
                          <h3 class="headline">
                            Bitte füllen Sie alle Felder aus
                          </h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="App Name"
                            v-model="app.name"
                          ></v-text-field>
                          <v-color-field
                            placeholder="Primär Farbe"
                            label="Primär Farbe"
                            v-model="app.color1"
                            :valueColor="app.color1"
                          ></v-color-field>
                          <v-color-field
                            class="pt-5"
                            v-model="app.color2"
                            :valueColor="app.color2"
                            placeholder="Sekundär Farbe"
                            label="Sekundär Farbe"
                          ></v-color-field>
                          <v-text-field
                            class="pt-5"
                            placeholder="API Key"
                            outlined
                            counter="36"
                            label="API Key"
                            v-model="app.apiKey"
                            @click:append="generateApiKey"
                            append-icon="mdi-wrench"
                          ></v-text-field>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <v-btn
                            :disabled="imageData == null"
                            large
                            color="primary"
                            @click="create"
                            >Speichern</v-btn
                          >
                          <v-btn
                            large
                            color="error"
                            @click="deleteDialog = true"
                            >LÖSCHEN</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-10">
                      <v-row class="mb-5">
                        <h2>Lade ein Logo hoch</h2>
                      </v-row>
                      <v-row>
                        <v-image-input
                          v-model="imageData"
                          :image-quality="1"
                          imageMinScaling="contain"
                          clearable
                          image-format="png"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >App Löschen</v-card-title
        >

        <v-card-text>
          Möchten Sie diese App wirklich löschen?
          <br />Sämtliche Produkte und dazugehörige Informationen werden
          unwiderruflich gelöscht.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              deleteDialog = false;
              deleteApp();
            "
            >Ja, Ich möchte die App löschen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import AppService from "@/services/AppService";
import AssetService from "@/services/AssetService";
import ColorField from "@/views/general/components/ColorPicker";

export default {
  name: "dashboard",
  components: {
    Header: Header,
    "v-color-field": ColorField,
  },
  data: () => ({
    loading: true,
    imageData: null,
    deleteDialog: false,
    app: null,
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    generateApiKey() {
      this.app.apiKey = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );

      return true;
    },
    async uploadImage() {},
    async create() {
      let payload = this.app;

      this.loading = true;

      payload.imageId = (await AssetService.upload(this.imageData)).data.id;

      //fix color hex
      this.app.color1 = this.app.color1.slice(0,7)
      this.app.color2 = this.app.color2.slice(0,7)



      let appId = this.$route.params.id;
      let result = await AppService.update(appId, payload);
      if(result) {
        this.loading = false;
        router.push({ name: "Apps" });
      }
    },

    async deleteApp() {
      this.loading = true;
      let appId = this.$route.params.id;
      await AppService.delete(appId);

      this.loading = false;
      router.push({ name: "Apps" });
    },
    async refresh() {
      this.loading = true;

      let appId = this.$route.params.id;
      let app = (await AppService.getApp(appId)).data;

      //load image
      let imageData = await AssetService.getAsBase64(app.assetId);
      this.imageData = imageData;
      this.app = app;

      
      try {
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    },
  },
};
</script>

